import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import {
    ProductInventoryDto,
    RealTimeInventoryModel,
    RealTimePricingModel,
} from "@insite/client-framework/Types/ApiModels";
import { GetPartCollectionApiParameter } from "@store/Services/PartsService";
import { DisplayPartsResult } from "@store/Store/Pages/ProductDetails/Parts/Handlers/DisplayParts";
import ProductDetailsPartsState from "@store/Store/Pages/ProductDetails/Parts/ProductDetailsPartsState";
import { Draft } from "immer";

const initialState: ProductDetailsPartsState = {
    productInfosByProductId: {},
};

const reducer = {
    "Store/Pages/ProductDetails/Parts/BeginLoad": (draft: Draft<ProductDetailsPartsState>) => {
        draft.isLoading = true;
    },
    "Store/Pages/ProductDetails/Parts/SetParameter": (
        draft: Draft<ProductDetailsPartsState>,
        action: { parameter: GetPartCollectionApiParameter },
    ) => {
        draft.lastParameter = draft.parameter;
        draft.parameter = action.parameter;
    },
    "Store/Pages/ProductDetails/Parts/CompleteLoad": (
        draft: Draft<ProductDetailsPartsState>,
        action: { result: DisplayPartsResult },
    ) => {
        draft.productInfosByProductId = action.result.productInfosByProductId;
        draft.isLoading = false;
        draft.isReady = true;
    },
    "Store/Pages/ProductDetails/Parts/ChangeQtyOrdered": (
        draft: Draft<ProductDetailsPartsState>,
        action: { qtyOrdered: number; productId: string },
    ) => {
        const productInfo = draft.productInfosByProductId[action.productId];
        if (productInfo) {
            productInfo.qtyOrdered = action.qtyOrdered;
        }
    },
    "Store/Pages/ProductDetails/Parts/CompleteLoadRealTimePricing": (
        draft: Draft<ProductDetailsPartsState>,
        action: { realTimePricing: RealTimePricingModel },
    ) => {
        action.realTimePricing.realTimePricingResults?.forEach(pricing => {
            const productInfo = draft.productInfosByProductId[pricing.productId];
            if (productInfo) {
                productInfo.pricing = pricing;
                delete productInfo.failedToLoadPricing;
            }
        });
    },
    "Store/Pages/ProductDetails/Parts/FailedLoadRealTimePricing": (
        draft: Draft<ProductDetailsPartsState>,
        action: { productId?: string },
    ) => {
        if (action.productId) {
            const productInfo = draft.productInfosByProductId[action.productId];
            if (productInfo) {
                productInfo.failedToLoadPricing = true;
            }
            return;
        }

        for (const productId in draft.productInfosByProductId) {
            draft.productInfosByProductId[productId]!.failedToLoadPricing = true;
        }
    },
    "Store/Pages/ProductDetails/Parts/ClearState": (draft: Draft<ProductDetailsPartsState>) => {
        draft.lastParameter = undefined;
        draft.parameter = undefined;
        draft.productInfosByProductId = {};
        draft.isReady = false;
    },
    "Store/Pages/ProductDetails/CompleteLoadRealTimeInventory": (
        draft: Draft<ProductDetailsPartsState>,
        action: { realTimeInventory: RealTimeInventoryModel },
    ) => {
        action.realTimeInventory.realTimeInventoryResults?.forEach((inventory: ProductInventoryDto) => {
            const productInfo = draft.productInfosByProductId[inventory.productId];
            if (productInfo) {
                productInfo.inventory = inventory;
            }
        });
    },
};

const productDetailsPartsReducer = createTypedReducerWithImmer(initialState, reducer);
export default productDetailsPartsReducer;
